(function(){
    'use strict'; 
    angular.module('Filters').filter('bbaSnakeCaseToSentenceText', bbaSnakeCaseToSentenceText);
    
    bbaSnakeCaseToSentenceText.$inject = []; 
    
    function bbaSnakeCaseToSentenceText() {

        return function (text) {
            if (!text) { return; }
            return text.replace(/_/g, ' ').toUpperCase();
        }
    }
})()


// WEBPACK FOOTER //
// ./js/filters/bbaSnakeCaseToSentenceText.js